import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type SectionHeaderProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  to?: string;
  more?: string;
  action?: ReactNode;
};

export default function SectionHeader({
  eyebrow,
  title,
  desc,
  to,
  more = '查看全部',
  action,
}: SectionHeaderProps) {
  return (
    <div className="mb-7 flex items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <p className="lede-mark mb-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      <div className="hidden shrink-0 items-center gap-3 md:flex">
        {action}
        {to && (
          <Link
            to={to}
            className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-800"
          >
            {more}
            <i className="ri-arrow-right-line ml-1 text-sm" aria-hidden="true" />
          </Link>
        )}
      </div>
    </div>
  );
}